module.exports = __webpack_public_path__ + "img/img25.0177a943.png";